import React from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { Flex, Text } from "@jsq/ds/core";
import { FundsTable, FundRowItem } from "@jsq/payments-components";
import {
  cashProcessingContainer,
  cashProcessingHeader,
  cashProcessingTableContainer,
} from "./styles_vanilla.css";

export const CashProcessing: React.FC = () => {
  const history = useHistory();
  const { path } = useRouteMatch();

  const handleFundClick = (fund: FundRowItem) => {
    history.push(`${path}/fund/${fund.id}`);
  };

  return (
    <Flex className={cashProcessingContainer}>
      <Flex className={cashProcessingHeader}>
        <Text variant="h2">Funds</Text>
      </Flex>
      <Flex className={cashProcessingTableContainer}>
        <FundsTable onFundClick={handleFundClick} />
      </Flex>
    </Flex>
  );
};
